import { useContext } from "react";
import ProductContext from "../components/ProductLayout/context";

export default () => useContext(ProductContext);
